//Get the Hiistory of Units
export const GET_HISTORY_LIST_ROUND = "GET_HISTORY_LIST_ROUND";
export const GET_HISTORY_LIST_ROUND_SUCCESS = "GET_HISTORY_LIST_ROUND_SUCCESS";
export const GET_HISTORY_LIST_ROUND_FAIL = "GET_HISTORY_LIST_ROUND_FAIL";

export const GET_HISTORY_LIST_CSR = "GET_HISTORY_LIST_CSR";
export const GET_HISTORY_LIST_CSR_SUCCESS = "GET_HISTORY_LIST_CSR_SUCCESS";
export const GET_HISTORY_LIST_CSR_FAIL = "GET_HISTORY_LIST_CSR_FAIL";

export const GET_RESULT_HISTORY = "GET_RESULT_HISTORY";
export const GET_RESULT_HISTORY_SUCCESS = "GET_RESULT_HISTORY_SUCCESS";
export const GET_RESULT_HISTORY_FAIL = "GET_RESULT_HISTORY_FAIL";

export const SEND_CHAT_MESSAGE = "SEND_CHAT_MESSAGE";
export const SEND_CHAT_MESSAGE_SUCCESS = "SEND_CHAT_MESSAGE_SUCCESS";
export const SEND_CHAT_MESSAGE_FAIL = "SEND_CHAT_MESSAGE_FAIL";

export const SEND_PARTICIPANT_CHAT = "SEND_PARTICIPANT_CHAT";
export const SEND_PARTICIPANT_CHAT_SUCCESS = "SEND_PARTICIPANT_CHAT_SUCCESS";
export const SEND_PARTICIPANT_CHAT_FAIL = "SEND_PARTICIPANT_CHAT_FAIL";

export const GET_PARTICIPANT_HISTORY = "GET_PARTICIPANT_HISTORY";
export const GET_PARTICIPANT_HISTORY_SUCCESS =
  "GET_PARTICIPANT_HISTORY_SUCCESS";
export const GET_PARTICIPANT_HISTORY_FAIL = "GET_PARTICIPANT_HISTORY_FAIL";
